import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'entering:animate-in entering:fade-in exiting:animate-out exiting:fade-out z-10001 max-h-60 w-(--menu-width) overflow-auto bg-white shadow-[0_4px_11px_0_rgba(29,31,34,0.1)]',
    listbox: 'outline-hidden',
    option:
      'heading-s flex cursor-default items-center gap-0.5 px-4 py-3 select-none hover:cursor-pointer'
  },
  variants: {
    state: {
      default: {
        base: 'p-3',
        option:
          'data-[focus=true]:bg-color-secondary focus:bg-color-secondary hover:bg-color-accent py-2'
      },
      map: {
        base: 'px-4 py-2',
        option:
          'data-[focus=true]:bg-bg-items-white focus:bg-bg-items-white hover:bg-bg-items-surface hover:bg-surface py-3'
      },
      static: {
        base: 'p-3',
        option: 'py-2'
      }
    }
  },
  defaultVariants: {
    state: 'default'
  }
});
